module.exports = "<div class=c-search-sidebar__filter-chip-wrapper> <div class=c-search-sidebar__filter-chip> {{filter.text}} </div> <button v-on:click=\"emitRemoveFilter(filter.fieldname, filter.text)\" class=\"c-search-sidebar__filter-chip-remove i-icon i-remove-filter\" :title=\"trans('Remove filter') + ': ' + filter.text\"> {{ trans(\"Remove filter\") + \": \" + filter.text }}</button> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/frontend/pages/explore-the-archive/archive/templates/filter-chip.html
// module id = 136
// module chunks = 0